<template>
  <div>
    <OnlineApplication />
  </div>
</template>

<script>
import OnlineApplication from "./online_application/OnlineApplication.vue";

export default {
  name: "OnlineLoanApplication",
  components: {
    OnlineApplication,
  },
  data() {
    return {};
  },
};
</script>

<style scoped></style>
